<template>
  <VMenu
    v-model="isOpen"
    class="menu-component"
    lazy
    contentClass="contrast"
    offsetY
    :closeOnContentClick="closeOnContentClick"
    left
  >
    <slot slot="activator" name="activator" />

    <slot />
  </VMenu>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },
}
</script>
<style lang="postcss" scoped>
.menu-component {
  display: flex !important;
  & >>> .v-menu__activator {
    align-items: stretch;
  }
}
</style>
